import { NavLink, Outlet, useLocation } from "react-router-dom";
import { ArrowRightLeft, LayoutDashboard, Plug, Library, ListOrdered, Users, ClipboardCheck, Settings2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** The journey, in the order an administrator actually works through it. */
const TABS = [
  { to: "/org/migrations", label: "Overview", end: true, icon: LayoutDashboard, stage: null },
  { to: "/org/migrations/sources", label: "1 · Connect", icon: Plug, stage: "Connect a source platform" },
  { to: "/org/migrations/courses", label: "2 · Choose courses", icon: Library, stage: "Discover and select what to bring across" },
  { to: "/org/migrations/users", label: "3 · Match people", icon: Users, stage: "Match source users to TMC accounts — do this before importing history" },
  { to: "/org/migrations/queue", label: "4 · Migrate", icon: ListOrdered, stage: "Watch the import run" },
  { to: "/org/migrations/review", label: "5 · Resolve", icon: ClipboardCheck, stage: "Finish anything the import could not do automatically" },
  { to: "/org/migrations/settings", label: "Settings", icon: Settings2, stage: null },
];

export default function MigrationLayout() {
  const loc = useLocation();
  const current = TABS.filter((t) => t.stage).find((t) => loc.pathname.startsWith(t.to));
  return (
    <div data-testid="migration-assistant">
      <div className="flex items-center gap-3 mb-3">
        <span className="h-9 w-9 rounded-sm bg-slate-900 text-white flex items-center justify-center shrink-0"><ArrowRightLeft size={16} aria-hidden /></span>
        <div className="min-w-0">
          <h1 className="font-heading font-bold text-lg sm:text-xl leading-tight text-slate-900 tracking-tight" data-testid="page-title">Data migration</h1>
          <p className="text-xs text-slate-500">Bring courses, content, people and completion history from another learning platform into TMC Learning.</p>
        </div>
      </div>
      <nav className="flex gap-0.5 border-b border-slate-200 overflow-x-auto" aria-label="Migration journey">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={`mig-tab-${t.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={({ isActive }) => cn("px-3 py-2 text-sm whitespace-nowrap border-b-2 -mb-px inline-flex items-center gap-1.5 transition-colors", isActive ? "border-sky-600 text-sky-700 font-semibold" : "border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300")}>
            <t.icon size={14} aria-hidden /> {t.label}
          </NavLink>))}
      </nav>
      {current && <p className="text-xs text-slate-600 bg-slate-100 border border-t-0 border-slate-200 rounded-b px-3 py-1.5 mb-4" data-testid="migration-stage-hint">{current.stage}</p>}
      {!current && <div className="mb-4" />}
      <Outlet />
    </div>
  );
}
